import React, { ChangeEvent } from 'react';
import { Box, Text, Checkbox } from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { useSeekersFilters } from '../filters/SeekersFiltersContext';
import { SearchAndSortProps } from './searchAndSortType';

export const PriorityCandidatesView = ({ tempSearchAndSortType, setTempSearchAndSortTypes }: SearchAndSortProps): JSX.Element => {
  const { t } = useTranslation();
  const { setIsFromSearchAndSort } = useSeekersFilters();

  const onHandlePriority = (isPriorityApplied: boolean) => {
    const updatedFilters = {
      ...tempSearchAndSortType,
      isPriorityCandidates: isPriorityApplied,
    };
    setIsFromSearchAndSort(true);
    setTempSearchAndSortTypes(updatedFilters);
  };
  return (
    <Box>
      <Checkbox
        data-testid="proprotyCheckBox"
        isChecked={tempSearchAndSortType.isPriorityCandidates}
        onChange={(e: ChangeEvent<HTMLInputElement>) => onHandlePriority(e.target.checked)}
      >
        <Text
          px={3}
          style={{
            fontSize: '14px',
            fontWeight: 'normal',
          }}
        >
          {t('searchAndSort.priority')}
        </Text>
      </Checkbox>
    </Box>
  );
};
